var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M37 45H11a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h19l10 10v29a3 3 0 0 1-3 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8e6c9",
    d: "M40 13H30V3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e7d32",
    d: "m30 13 10 10V13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8f5e9",
    d: "M31 23H15v14h18V23h-2zm-14 2h4v2h-4v-2zm0 4h4v2h-4v-2zm0 4h4v2h-4v-2zm14 2h-8v-2h8v2zm0-4h-8v-2h8v2zm0-4h-8v-2h8v2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSheet);
export default __webpack_public_path__ + "static/media/logo-sheet.26085f61526c0c37e041a303e935b280.svg";
export { ForwardRef as ReactComponent };